import * as React from "react";
import { FieldWithTooltipContainer } from "./Tooltip.style";
import type { WithTooltipProps } from "./Tooltip.interface";
import { SvyIcon, SvyTooltip } from "@/indicators";

export const withTooltip = <P, Ref extends HTMLElement>(Component: React.ComponentType<P>) => {
    const newComponent = React.forwardRef<Ref, P & WithTooltipProps>((props, ref) => {
        const { tooltip, ...rest } = props;
        if (!tooltip) {
            return <Component ref={ref} {...(rest as P)} />;
        }
        return (
            <FieldWithTooltipContainer>
                <Component ref={ref} {...(rest as P)} />
                <SvyTooltip tooltipContent={tooltip}>
                    <SvyIcon icon="information-line" />
                </SvyTooltip>
            </FieldWithTooltipContainer>
        );
    });
    newComponent.displayName = Component.displayName;
    return newComponent;
};
